"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.184 4.987a2.27 2.27 0 0 0-2.367 0c-1.368.837-3.253 2-4.104 2.573a.7.7 0 0 0 0 1.161l3.62 2.435a1 1 0 0 1 .082.056l.41.275a2.11 2.11 0 0 0 2.353 0l.4-.268a1 1 0 0 1 .1-.068l3.611-2.43a.7.7 0 0 0 0-1.162c-.85-.572-2.736-1.736-4.105-2.572M15.6 10.2l-2.485 1.672 2.352 2.353c.086-.21.133-.439.133-.678zm-1.123 5.015-2.546-2.547a3.51 3.51 0 0 1-3.86 0l-2.548 2.547a1.8 1.8 0 0 0 .678.132H13.8q.362-.002.677-.133m-9.944-.99 2.354-2.354-2.486-1.673v3.349c0 .24.047.469.132.678m-.602-7.827c-.595.4-.904 1.03-.926 1.667zm-.926 1.667L3 8.14v5.407a3.2 3.2 0 0 0 3.2 3.2h7.6a3.2 3.2 0 0 0 3.2-3.2V8.14l-.002-.046a2.08 2.08 0 0 0-.927-1.696c-.882-.593-2.797-1.775-4.157-2.606a3.67 3.67 0 0 0-3.828 0c-1.359.832-3.273 2.013-4.155 2.606",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=EmailOpenIcon20.js.map